<div class="onboarding">
  <div class="onboarding-floating-container">
    <section class="onboarding-container d-flex">
      <div class="card card-onboarding m-0 m-sm-auto">
        <div class="h-100 card-content">
          <div class="h-100 card-body px-1 px-md-3">
            <aw-wizard
              #wizard
              [disableNavigationBar]="true"
              class="h-100 wizard-onboarding"
            >
              <aw-wizard-step
                [stepTitle]="'Step 1'"
                [navigationSymbol]="{
                  symbol: '&#xf007;',
                  fontFamily: 'FontAwesome'
                }"
                style="
                  background-image: url(../../../../assets/img/confetti.png);
                  background-size: cover;
                "
              >
                <ngb-progressbar type="warning" [value]="25"></ngb-progressbar>
                <div class="h-100 w-100 py-2 px-1 p-md-4">
                  <div class="row">
                    <div class="col-12">
                      <h4
                        class="onboarding-step-1-header-title text-center font-size-10 font-size-md-12 m-0"
                      >
                        OPORTUNIDADE
                        <br />
                        <span class="text-primary text-bold-900"
                          >IMPERDÍVEL!</span
                        >
                      </h4>
                    </div>
                    <div *ngIf="configTimer.leftTime > 0" class="col-12 mt-3">
                      <div
                        class="w-100 d-flex justify-content-center align-items-center"
                      >
                        <span class="text-center onboarding-step-1-counter">
                          Esta oferta sai do ar em
                          <b>
                            <countdown [config]="configTimer"></countdown>
                          </b>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-12">
                      <div
                        class="d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-around"
                      >
                        <div
                          class="card first-step-card w-100 shadow-lg border mt-0 m-lg-0"
                        >
                          <div class="card-content">
                            <div class="card-body px-2 px-md-3">
                              <div class="w-100 d-flex flex-lg-column">
                                <div class="w-100">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center align-items-center"
                                  >
                                    <span
                                      class="text-primary font-size-13 text-bold-700 leadind-none"
                                    >
                                      2
                                    </span>
                                    <span
                                      class="ml-1 ml-lg-2 font-size-8 text-bold-700"
                                    >
                                      MESES
                                      <br />
                                      GRÁTIS
                                    </span>
                                  </div>
                                </div>
                                <div class="px-2 px-lg-0 py-lg-2">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center separator"
                                  >
                                    <div class="bg-secondary"></div>
                                  </div>
                                </div>
                                <div class="w-100">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center align-items-center"
                                  >
                                    <span class="font-size-4 text-center">
                                      Mais tempo de plataforma para você!
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <i
                          class="ft-plus font-size-7 font-size-lg-12 mx-lg-2 mx-xl-3"
                        ></i>
                        <div
                          class="card first-step-card w-100 shadow-lg border m-lg-0"
                        >
                          <div class="card-content">
                            <div class="card-body px-2 px-md-3">
                              <div class="w-100 d-flex flex-lg-column">
                                <div class="w-100">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center align-items-center"
                                  >
                                    <div class="d-flex flex-column">
                                      <div
                                        class="d-flex align-items-center justify-content-lg-center"
                                      >
                                        <span
                                          class="d-block text-primary font-size-13 text-bold-700 leadind-none"
                                        >
                                          1
                                        </span>
                                        <span
                                          class="ml-1 ml-lg-2 d-block font-size-9 text-bold-700"
                                        >
                                          ANO DE
                                          <br />
                                          ACESSO
                                        </span>
                                      </div>
                                      <span
                                        class="mt-1 font-size-1 font-size-md-3 text-bold-700 truncate"
                                        >À COMUNIDADE OPD ACADEMY</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div class="px-2 px-lg-0 py-lg-2">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center separator"
                                  >
                                    <div class="bg-secondary"></div>
                                  </div>
                                </div>
                                <div class="w-100">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center align-items-center"
                                  >
                                    <span class="font-size-4 text-center">
                                      <b>Mentorias mensais</b> sobre captação de
                                      alunos, vendas e mais!
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <i
                          class="ft-plus font-size-7 font-size-lg-12 mx-lg-2 mx-xl-3"
                        ></i>
                        <div
                          class="card first-step-card w-100 shadow-lg border mb-0 m-lg-0"
                        >
                          <div class="card-content">
                            <div class="card-body px-2 px-md-3">
                              <div class="w-100 d-flex flex-lg-column">
                                <div class="w-100">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center align-items-center"
                                  >
                                    <div class="d-flex flex-column">
                                      <span
                                        class="text-primary font-size-10 font-size-lg-11 text-bold-700"
                                      >
                                        +R$500,00
                                      </span>
                                      <span
                                        class="mt-1 font-size-3 font-size-lg-5 text-bold-700"
                                        >EM BÔNUS EXCLUSIVOS</span
                                      >
                                    </div>
                                  </div>
                                </div>
                                <div class="px-2 px-lg-0 py-lg-2">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center separator"
                                  >
                                    <div class="bg-secondary"></div>
                                  </div>
                                </div>
                                <div class="w-100">
                                  <div
                                    class="h-100 w-100 d-flex justify-content-center align-items-center"
                                  >
                                    <span class="font-size-4 text-center">
                                      Para alavancar sua carreira profissional!
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-12">
                      <div
                        class="w-100 d-flex flex-column justify-content-center align-items-center footer-container"
                      >
                        <button
                          type="button"
                          class="btn btn-success btn-lg onboarding-step-1-btn-offer"
                          (click)="updateOnboardingProgress(2, null, true)"
                        >
                          Garantir Oportunidade
                        </button>
                        <span
                          class="text-center my-2 onboarding-step-1-or-text"
                        >
                          ou
                        </span>
                        <button
                          type="button"
                          class="btn shadow-none onboarding-step-1-btn-start-test"
                          awNextStep
                          (click)="updateOnboardingProgress(3, null, false)"
                        >
                          Iniciar Teste Grátis
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </aw-wizard-step>
              <aw-wizard-step
                [stepTitle]="'Step 2'"
                [navigationSymbol]="{
                  symbol: '&#xf007;',
                  fontFamily: 'FontAwesome'
                }"
              >
                <ngb-progressbar type="warning" [value]="50"></ngb-progressbar>
                <div class="row">
                  <div class="col-12">
                    <span
                      class="d-block text-center onboarding-step-2-subheadline"
                    >
                      Quantos alunos você atende online e presencialmente?
                    </span>
                    <span
                      class="d-block text-center onboarding-step-2-click-text mt-2"
                    >
                      (Clique em uma das opções)
                    </span>
                  </div>
                </div>
                <div class="row mt-3 mt-md-5">
                  <div class="col-12 col-md-4 mt-2 mt-lg-0 text-center">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-lg btn-customer-number"
                      (click)="updateOnboardingProgress(4, 1, false)"
                      awNextStep
                    >
                      <span class="customer-text">Até</span><br />
                      <span class="customer-number">5</span><br />
                      <span class="customer-text">alunos</span>
                    </button>
                  </div>
                  <div class="col-12 col-md-4 mt-2 mt-lg-0 text-center">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-lg btn-customer-number"
                      (click)="updateOnboardingProgress(4, 2, false)"
                      awNextStep
                    >
                      <span class="customer-text">Entre</span><br />
                      <span class="customer-number">6-15</span><br />
                      <span class="customer-text">alunos</span>
                    </button>
                  </div>
                  <div class="col-12 col-md-4 mt-2 mt-lg-0 text-center">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-lg btn-customer-number"
                      (click)="updateOnboardingProgress(4, 3, false)"
                      awNextStep
                    >
                      <span class="customer-text">Mais de</span><br />
                      <span class="customer-number">15</span><br />
                      <span class="customer-text">alunos</span>
                    </button>
                  </div>
                </div>

                <div class="row mt-3 mt-md-5">
                  <div class="col-12">
                    <div class="form-group text-center text-md-left m-0">
                      <button
                        type="button"
                        class="btn btn-light btn-lg onboarding-btn-back-step2"
                        awPreviousStep
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                </div>
              </aw-wizard-step>
              <aw-wizard-step
                [stepTitle]="'Step 3'"
                [navigationSymbol]="{
                  symbol: '&#xf0ac;',
                  fontFamily: 'FontAwesome'
                }"
              >
                <ngb-progressbar type="warning" [value]="75"></ngb-progressbar>
                <div class="row">
                  <div class="col-12">
                    <span
                      class="d-block onboarding-step-3-header-title text-center"
                    >
                      Parabéns pelo seu cadastro, Personal!
                    </span>
                    <span
                      class="d-block text-center onboarding-step-3-subheadline mt-2"
                    >
                      Convide seu aluno para baixar o app e ganhe uma
                      <b>planilha de controle financeiro!</b>
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 text-center">
                    <img
                      src="../../../../assets/img/presente-confetti.svg"
                      class="onboarding-img-plane"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <span
                      class="d-block text-center onboarding-step-3-help-text mt-2"
                    >
                      Compartilhe com seus alunos:
                    </span>
                    <div class="form-group text-center mt-2">
                      <button
                        class="btn btn-success btn-lg onboarding-btn-whatsapp font-size-7 font-size-lg-9"
                        (click)="cancelarWhatsApp()"
                      >
                        <i class="fa fa-whatsapp"></i> Compartilhar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row row-footer d-md-none">
                  <div class="col-6">
                    <div class="form-group text-center">
                      <button
                        type="button"
                        class="btn btn-light btn-lg onboarding-btn-back font-size-7"
                        awPreviousStep
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group text-center">
                      <button
                        type="button"
                        class="btn btn-light btn-lg onboarding-btn-go-plataform font-size-7"
                        (click)="updateOnboardingProgress(5, null, false)"
                        awNextStep
                      >
                        <i class="ft ft-log-in"></i> Avançar
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row row-footer d-none d-md-flex">
                  <div class="col-6">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-light btn-lg onboarding-btn-back float-left"
                        awPreviousStep
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-light btn-lg onboarding-btn-go-plataform float-right"
                        (click)="updateOnboardingProgress(5, null, false)"
                        awNextStep
                      >
                        <i class="ft ft-log-in"></i> Avançar
                      </button>
                    </div>
                  </div>
                </div>
              </aw-wizard-step>
              <aw-wizard-step
                [stepTitle]="'Step 4'"
                [navigationSymbol]="{
                  symbol: '&#xf0ac;',
                  fontFamily: 'FontAwesome'
                }"
              >
                <ngb-progressbar type="warning" [value]="100"></ngb-progressbar>
                <div class="row mt-3">
                  <div class="col-12 text-center">
                    <span class="d-block d-md-inline font-size-7">
                      Bem-vindo, personal!
                    </span>
                    <span class="d-block d-md-inline font-size-7 mt-1 mt-md-0">
                      O que deseja fazer agora?
                    </span>
                  </div>
                </div>
                <div class="row mt-3 mt-md-0">
                  <div class="col-12">
                    <div
                      class="w-100 d-flex flex-column flex-md-row justify-content-center align-items-center justify-content-lg-around"
                    >
                      <button
                        type="button"
                        (click)="updateOnboardingProgress(6, null, false)"
                        class="w-100 btn third-step-btn p-3 mt-0 mt-md-3 mx-md-2 mx-xl-3 border shadow-lg"
                      >
                        <ng-container
                          [ngTemplateOutlet]="svgTemplate"
                          [ngTemplateOutletContext]="{
                            type: 'generate-training'
                          }"
                        ></ng-container>
                        <span
                          class="d-block mt-2 mt-md-5 text-bold-600 leadind-1 font-size-5 font-size-md-10"
                          >CRIAR UM TREINO COM INTELIGÊNCIA ARTIFICIAL</span
                        >
                        <i class="ft-chevron-right font-size-7 d-md-none"></i>
                      </button>
                      <button
                        type="button"
                        (click)="updateOnboardingProgress(7, null, false)"
                        class="w-100 btn third-step-btn p-3 mt-3 mx-md-2 mx-xl-3 border shadow-lg"
                      >
                        <ng-container
                          [ngTemplateOutlet]="svgTemplate"
                          [ngTemplateOutletContext]="{
                            type: 'download-app'
                          }"
                        ></ng-container>
                        <span
                          class="d-block mt-2 mt-md-5 text-bold-600 leadind-1 font-size-5 font-size-md-10"
                          >BAIXAR APLICATIVO DO ALUNO</span
                        >
                        <i class="ft-chevron-right font-size-7 d-md-none"></i>
                      </button>
                      <button
                        type="button"
                        (click)="updateOnboardingProgress(8, null, false)"
                        class="w-100 btn third-step-btn p-3 mt-3 mx-md-2 mx-xl-3 border shadow-lg"
                      >
                        <ng-container
                          [ngTemplateOutlet]="svgTemplate"
                          [ngTemplateOutletContext]="{
                            type: 'add-client'
                          }"
                        ></ng-container>
                        <span
                          class="d-block mt-2 mt-md-5 text-bold-600 leadind-1 font-size-5 font-size-md-10"
                          >ADICIONAR SEUS ALUNOS</span
                        >
                        <i class="ft-chevron-right font-size-7 d-md-none"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row mt-4 mb-3">
                  <div class="col-12 d-flex">
                    <button
                      type="button"
                      (click)="updateOnboardingProgress(9, null, false)"
                      class="btn shadow-none m-auto d-flex align-items-center grey darken-2"
                    >
                      <span class="font-size-6 font-size-md-7 text-bold-500"
                        >Explorar sozinho</span
                      >
                      <i class="ft-chevron-right ml-2"></i>
                    </button>
                  </div>
                </div>
              </aw-wizard-step>
            </aw-wizard>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<ng-template #svgTemplate let-type="type">
  <svg
    *ngIf="type === 'add-client'"
    width="114"
    height="85"
    viewBox="0 0 114 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="add-client-svg"
  >
    <path
      d="M47.0737 9.63596C47.6722 9.49785 48.685 9.3137 49.318 9.22162C49.951 9.14105 51.0559 9.072 53.0701 9.10653L54.5548 12.4443L55.5101 12.5248C56.028 12.5709 56.9142 12.7435 57.4897 12.9046C58.0536 13.0773 58.8593 13.388 59.2736 13.6182C59.688 13.8369 60.3095 14.2512 60.6548 14.539C61.0001 14.8267 61.518 15.3216 61.8057 15.6554C62.0934 15.9776 62.5653 16.6337 62.8646 17.1056C63.1638 17.5775 63.6012 18.4407 63.8314 19.0046C64.0616 19.5686 64.4068 20.639 64.591 21.364C64.7866 22.1697 64.9708 23.3206 65.0514 24.2989C65.155 25.542 65.1434 26.2325 65.0399 27.3489C64.9593 28.1431 64.7982 29.1789 64.6716 29.6508C64.5565 30.1227 64.2572 30.9169 63.5897 32.2865L63.958 32.5742C64.1997 32.7699 64.4183 33.1036 64.568 33.5065C64.6946 33.8518 64.8327 34.4848 64.8672 34.9221C64.9132 35.4516 64.8787 36.004 64.7406 36.6716C64.637 37.2125 64.3953 38.0412 64.2112 38.5131C64.027 38.9849 63.6817 39.641 63.4516 39.9517C63.1523 40.3431 62.8185 40.6193 61.7482 41.1487L61.5525 42.1615C61.4489 42.714 61.2302 43.6117 61.0576 44.1527C60.885 44.6936 60.4591 45.7295 60.1138 46.4546C59.7685 47.1796 59.2621 48.1004 58.9744 48.5032C58.6982 48.8946 58.3299 49.3089 57.858 49.6196L57.927 53.1876C57.9846 56.3642 58.0191 56.813 58.2148 57.2734C58.3414 57.5611 58.6752 58.1021 58.9514 58.4819C59.2391 58.8617 59.6995 59.3566 59.9757 59.5868C60.2519 59.8055 60.7929 60.2083 61.1727 60.4615C61.5525 60.7147 62.4387 61.2096 63.1293 61.5549C63.8199 61.9117 65.7189 62.7173 67.3302 63.3734C68.9415 64.0179 70.9672 64.8581 71.8189 65.2494C72.6706 65.6407 73.9136 66.2507 74.5812 66.6305C75.2487 66.9988 76.1925 67.5973 76.6989 67.9541C77.1938 68.3109 77.9189 68.8979 78.3102 69.2547C78.69 69.6115 79.3115 70.256 79.6683 70.6934C80.0251 71.1307 80.5545 71.9019 80.8538 72.4083C81.1415 72.9147 81.5328 73.7434 81.7285 74.2498C81.9242 74.7562 82.1774 75.5618 82.304 76.0337C82.4191 76.5056 82.5226 77.1156 82.5226 77.3918C82.5226 77.6566 82.4306 78.0364 82.3155 78.2205C82.2119 78.4162 81.9357 78.6464 81.694 78.7384C81.3142 78.8881 77.401 78.9111 49.6057 78.9111C19.7043 78.9111 17.9319 78.8996 17.5405 78.7154C17.2988 78.6003 17.0111 78.3471 16.873 78.163C16.6773 77.8867 16.6313 77.6451 16.6313 77.012C16.6428 76.4826 16.7464 75.8726 16.942 75.2281C17.1147 74.6871 17.506 73.7318 17.8283 73.0988C18.1505 72.4658 18.6454 71.6371 18.9332 71.2573C19.2209 70.8775 19.7734 70.233 20.1762 69.8302C20.5675 69.4273 21.2581 68.8058 21.6954 68.449C22.1328 68.0922 22.973 67.5053 23.5369 67.16C24.1009 66.8032 25.0447 66.2853 25.6086 65.9975C26.1726 65.7098 27.1854 65.2379 27.853 64.9502C28.4757 64.6818 30.0297 64.0528 31.4128 63.4931L31.7086 63.3734C33.1588 62.7979 34.9773 62.0153 35.7369 61.647C36.4965 61.2787 37.4518 60.7492 37.8661 60.4845C38.2805 60.2083 39.0056 59.5983 39.4775 59.1264C39.9839 58.62 40.4903 57.987 40.6744 57.6187C40.9847 56.9866 40.9852 56.9742 41.2488 49.7661L41.2499 49.7347L40.6399 49.1593C40.3061 48.8485 39.8573 48.3191 39.6501 48.0083C39.4429 47.6976 39.0401 46.961 38.7524 46.397C38.4646 45.833 38.0848 44.9238 37.8892 44.3829C37.705 43.8419 37.4633 42.9902 37.3597 42.4838C37.2446 41.9774 37.1411 41.4595 37.118 41.3329C37.095 41.1948 36.8418 40.9876 36.462 40.7919C36.1282 40.6308 35.6794 40.3085 35.4722 40.0783C35.2765 39.8482 34.9773 39.3993 34.8162 39.0885C34.655 38.7663 34.4133 38.1102 34.2752 37.6268C34.0911 36.9708 34.022 36.3953 34.022 35.5206C34.0105 34.3812 34.0335 34.2661 34.3788 33.564C34.5745 33.1497 34.8622 32.7008 35.2765 32.298L34.8507 31.055C34.6205 30.3759 34.3212 29.3055 34.1831 28.6725C34.022 27.9129 33.9184 26.9116 33.8724 25.7376C33.8379 24.4371 33.8609 23.6429 33.999 22.8027C34.0911 22.1697 34.2982 21.2029 34.4594 20.639C34.632 20.0865 34.9773 19.1542 35.2535 18.5788C35.5297 17.9918 35.9441 17.2207 36.1628 16.8754C36.3814 16.5301 36.8994 15.828 37.3022 15.3331C37.705 14.8267 38.4301 14.0786 38.9135 13.6643C39.3969 13.2499 40.145 12.6629 40.5824 12.3637C41.0197 12.076 41.8944 11.5695 42.5275 11.2588C43.1605 10.9365 44.1963 10.4992 44.8293 10.2805C45.4624 10.0618 46.4752 9.77407 47.0737 9.63596Z"
      fill="#FD7919"
    />
    <path
      d="M68.9329 18.2323C69.4739 18.1517 70.6593 18.0597 71.5801 18.0021C72.5008 17.9561 73.341 17.9215 73.4561 17.9331C73.6172 17.9446 73.8244 18.2898 74.2387 19.2681C74.6646 20.2695 74.8603 20.6147 75.0559 20.6723C75.2055 20.7183 75.5048 20.7644 75.7235 20.7644C75.9421 20.7644 76.437 20.8449 76.8169 20.937C77.1967 21.0291 77.8987 21.3053 78.3706 21.5355C79.0152 21.8463 79.464 22.18 80.1201 22.8591C80.8797 23.6187 81.1099 23.9525 81.6508 25.0574C81.9961 25.7595 82.3759 26.7608 82.514 27.2672C82.6406 27.7736 82.8017 28.6253 82.8708 29.1662C82.9514 29.7302 82.9744 30.8121 82.9399 31.6983C82.9053 32.7226 82.8018 33.5628 82.6406 34.1728C82.5025 34.6792 82.2723 35.3583 81.835 36.2445L82.1112 36.5323C82.2608 36.6934 82.468 37.0502 82.5716 37.3379C82.6636 37.6257 82.7442 38.2011 82.7442 38.6385C82.7442 39.0643 82.6636 39.7894 82.56 40.2498C82.4565 40.6987 82.2493 41.3432 82.0997 41.6539C81.9616 41.9762 81.6623 42.4021 81.4551 42.6092C81.248 42.8164 80.9142 43.0351 80.7301 43.0926C80.4193 43.1962 80.3733 43.2653 80.2927 43.8637C80.2467 44.232 80.028 45.0492 79.8208 45.6822C79.6136 46.3153 79.2684 47.167 79.0612 47.5813C78.854 47.9956 78.4627 48.6517 78.1865 49.0545C77.9102 49.4458 77.611 49.7681 77.5304 49.7681C77.4269 49.7681 77.4153 50.2169 77.4729 51.8628C77.5535 53.8654 77.5765 54.0035 77.8757 54.5905C78.0714 54.9588 78.4972 55.4883 78.9461 55.8911C79.3604 56.2594 80.0855 56.7658 80.5574 57.019C81.0293 57.2607 81.835 57.629 82.3414 57.8247C82.8478 58.0318 84.1944 58.5267 85.3338 58.9411C86.4733 59.3439 88.05 59.9884 88.8442 60.3797C89.6383 60.7596 90.6397 61.3235 91.0885 61.6228C91.5259 61.9335 92.228 62.509 92.6308 62.9118C93.0336 63.3146 93.5515 63.9247 93.7932 64.2699C94.0234 64.6152 94.3572 65.1792 94.5298 65.5129C94.691 65.8352 94.9557 66.5143 95.1168 67.0092C95.2779 67.4926 95.4851 68.4133 95.5772 69.0463C95.6693 69.6794 95.7498 70.531 95.7498 70.9454C95.7498 71.5093 95.6923 71.8201 95.4966 72.1999C95.3355 72.4992 95.0708 72.7869 94.8291 72.9135C94.4493 73.1207 94.1155 73.1322 89.9606 73.1322C86.4733 73.1322 85.5065 73.0976 85.5065 72.9941C85.5065 72.9135 85.2302 72.269 84.8965 71.5784C84.5627 70.8878 84.0217 69.921 83.6995 69.4492C83.3772 68.9773 82.7327 68.1486 82.2608 67.6077C81.7889 67.0667 80.9487 66.2495 80.3848 65.7777C79.8093 65.3058 78.9116 64.6267 78.3706 64.2699C77.8297 63.9131 76.8169 63.3031 76.1263 62.9118C75.4357 62.532 74.1582 61.9105 73.3065 61.5307C72.4548 61.1509 70.5557 60.3682 69.1056 59.7813C67.6439 59.2058 65.8369 58.4232 65.0773 58.0433C64.3176 57.675 63.4084 57.1456 63.0401 56.8809C62.6833 56.6047 62.2805 56.2479 62.1539 56.0752C61.9352 55.776 61.9007 55.5458 61.751 50.9766L62.0963 50.5162C62.2805 50.263 62.5682 49.8486 62.7293 49.5954C62.902 49.3422 63.2242 48.7552 63.4544 48.3064C63.6846 47.846 64.0184 47.0749 64.2141 46.603C64.3982 46.1311 64.7205 45.2104 64.9046 44.5658C65.2269 43.4839 65.3074 43.3228 65.8714 42.7473C66.2052 42.4021 66.654 41.8611 66.8727 41.5388C67.0799 41.2281 67.4252 40.5721 67.6439 40.1002C67.8625 39.6283 68.1963 38.6385 68.3805 37.9134C68.5646 37.1883 68.7373 36.1755 68.7718 35.6691C68.8178 35.1626 68.7833 34.357 68.7142 33.8851C68.6452 33.4132 68.4725 32.6881 68.1042 31.5257L68.392 30.4323C68.5531 29.8338 68.7373 28.9476 68.8063 28.4757C68.8639 28.0038 68.9559 27.1176 68.9905 26.5191C69.025 25.9206 69.002 24.7236 68.9329 23.8719C68.8639 23.0202 68.7027 21.8002 68.5761 21.1672C68.4495 20.5342 68.2423 19.648 68.1157 19.2106C67.9891 18.7732 67.8971 18.3934 67.9201 18.3819C67.9431 18.3704 68.392 18.3014 68.9329 18.2323Z"
      fill="#656D78"
    />
    <path
      d="M27.384 18.474C27.9824 18.3359 28.8111 18.1748 29.2255 18.1287C29.6398 18.0712 30.3534 18.0251 31.6424 18.0021L31.3087 19.0149C31.1245 19.5674 30.8943 20.4076 30.7907 20.8795C30.6987 21.3513 30.5606 22.2376 30.48 22.8361C30.3994 23.4921 30.3764 24.6085 30.4109 25.6559C30.4455 26.6111 30.5836 27.9462 30.7102 28.6483C30.8368 29.3504 31.0439 30.2481 31.1705 30.6625C31.3662 31.307 31.3777 31.4566 31.2396 31.6983C31.159 31.8594 30.9864 32.3543 30.8483 32.7917C30.7102 33.2406 30.5721 34.0347 30.526 34.5757C30.4915 35.1281 30.5145 35.9798 30.5951 36.5323C30.6756 37.0732 30.8368 37.8904 30.9634 38.3507C31.0785 38.7996 31.3087 39.4902 31.4698 39.87C31.6309 40.2498 31.9532 40.8598 32.1834 41.2281C32.4136 41.5849 32.92 42.1949 33.2998 42.5747C33.9558 43.2192 34.0249 43.3343 34.3241 44.3587C34.5083 44.9571 34.8536 45.947 35.1068 46.5454C35.36 47.1439 35.8088 48.0762 36.1081 48.6171C36.3958 49.1581 36.8907 49.9177 37.7424 51.0341L37.5813 55.8105L37.236 56.2018C37.0403 56.4205 36.5915 56.7888 36.2462 57.019C35.9009 57.2607 35.0953 57.7096 34.4622 58.0203C33.8292 58.3426 31.8611 59.1828 30.0887 59.8848C28.3162 60.5984 25.8762 61.6688 24.6792 62.2558C23.4708 62.8543 21.9745 63.683 21.3415 64.1088C20.7085 64.5231 19.8568 65.1446 19.4425 65.4784C19.0281 65.8122 18.2225 66.5718 17.6585 67.1703C17.083 67.7573 16.3695 68.5744 16.0817 68.9888C15.794 69.4031 15.3451 70.0937 15.1034 70.5426C14.8502 70.9914 14.4704 71.751 13.8604 73.1322H9.48683C5.55061 73.1322 5.06721 73.1092 4.71042 72.925C4.49174 72.8214 4.1925 72.5452 4.04288 72.3265C3.77816 71.9467 3.76665 71.8546 3.8242 70.5426C3.85873 69.6678 3.97382 68.8277 4.13495 68.2407C4.26155 67.7343 4.59533 66.8826 4.86004 66.3531C5.12476 65.8237 5.6657 64.995 6.04551 64.5116C6.43683 64.0282 7.08136 63.3607 7.48419 63.0154C7.88702 62.6701 8.65815 62.1062 9.19909 61.7494C9.74003 61.3926 10.7414 60.8056 11.4434 60.4488C12.134 60.092 13.8259 59.3209 15.184 58.7454C16.5421 58.1584 18.2225 57.3873 18.9245 57.042C19.7532 56.6162 20.4208 56.1673 20.8696 55.753C21.2379 55.4077 21.6408 54.9128 21.7674 54.6596C21.963 54.2683 22.0091 53.8884 22.1242 50.1709L21.6177 49.5379C21.3415 49.1926 20.8696 48.433 20.5704 47.869C20.2711 47.3051 19.8568 46.2922 19.6266 45.6247C19.4079 44.9571 19.1893 44.186 19.1432 43.8983C19.0972 43.6105 19.0051 43.3113 18.936 43.2307C18.867 43.1502 18.7289 43.0811 18.6368 43.0811C18.5447 43.0811 18.2915 42.9545 18.0844 42.8049C17.8887 42.6438 17.5664 42.2179 17.3938 41.8611C17.2096 41.4928 17.0025 40.9634 16.9219 40.6756C16.8528 40.3879 16.7493 39.8239 16.6917 39.4096C16.6342 38.9953 16.6342 38.4083 16.6802 38.086C16.7262 37.7753 16.8528 37.3264 16.9679 37.1077C17.083 36.889 17.2672 36.6013 17.3823 36.4747C17.5779 36.256 17.5779 36.2215 17.2557 35.3238C17.083 34.8174 16.8413 33.9887 16.7378 33.4823C16.5996 32.8608 16.5306 32.0551 16.5306 31.0077C16.5306 29.9604 16.5996 29.1547 16.7378 28.5332C16.8413 28.0268 17.06 27.2787 17.2211 26.8644C17.3708 26.45 17.6585 25.8055 17.8542 25.4257C18.0498 25.0459 18.4181 24.4244 18.6713 24.0445C18.936 23.6647 19.4885 22.9972 19.9028 22.5598C20.3172 22.1225 21.0423 21.478 21.5142 21.1212C21.986 20.7644 22.8953 20.2119 23.5283 19.8781C24.1613 19.5559 25.036 19.1646 25.4849 19.0034C25.9223 18.8538 26.7855 18.6121 27.384 18.474Z"
      fill="#656D78"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M99.0814 22.7435H93.3365V28.4884C93.3365 29.1203 92.823 29.6373 92.1876 29.6373C91.5522 29.6373 91.0386 29.1203 91.0386 28.4884V22.7435H85.2938C84.6584 22.7435 84.1448 22.2265 84.1448 21.5946C84.1448 20.9626 84.6584 20.4456 85.2938 20.4456H91.0386V14.7007C91.0386 14.0688 91.5522 13.5518 92.1876 13.5518C92.823 13.5518 93.3365 14.0688 93.3365 14.7007V20.4456H99.0814C99.7168 20.4456 100.23 20.9626 100.23 21.5946C100.23 22.2265 99.7168 22.7435 99.0814 22.7435ZM92.1876 3.21106C82.0341 3.21106 73.8041 11.4377 73.8041 21.5946C73.8041 31.7514 82.0341 39.9781 92.1876 39.9781C102.341 39.9781 110.571 31.7514 110.571 21.5946C110.571 11.4377 102.341 3.21106 92.1876 3.21106Z"
      fill="#FD7919"
    />
    <circle
      cx="92.1876"
      cy="21.5946"
      r="19.273"
      stroke="white"
      stroke-width="4.15111"
    />
  </svg>
  <svg
    *ngIf="type === 'download-app'"
    width="114"
    height="85"
    viewBox="0 0 80 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="download-app-svg"
  >
    <path
      d="M43.1393 12.7072V77.7091C43.1356 79.1112 42.577 80.4548 41.5856 81.4462C40.5941 82.4376 39.2506 82.9962 37.8485 83H5.29085C3.88878 82.9962 2.5452 82.4376 1.55379 81.4462C0.562369 80.4548 0.00374054 79.1112 0 77.7091V12.7072C0.00374054 11.3052 0.562369 9.96159 1.55379 8.97017C2.5452 7.97875 3.88878 7.42012 5.29085 7.41638H37.8485C39.2506 7.42012 40.5941 7.97875 41.5856 8.97017C42.577 9.96159 43.1356 11.3052 43.1393 12.7072ZM37.8485 21.4182H5.29085V69.8201H37.8485V21.4182ZM12.7642 14.7196C12.7642 15.4213 13.0429 16.0941 13.539 16.5902C14.0351 17.0864 14.708 17.3651 15.4096 17.3651H27.7392C28.4408 17.3651 29.1137 17.0864 29.6098 16.5902C30.1059 16.0941 30.3846 15.4213 30.3846 14.7196C30.3846 14.018 30.1059 13.3452 29.6098 12.849C29.1137 12.3529 28.4408 12.0742 27.7392 12.0742H15.4096C14.708 12.0742 14.0351 12.3529 13.539 12.849C13.0429 13.3452 12.7642 14.018 12.7642 14.7196ZM24.2104 76.41C24.2104 75.8889 24.0559 75.3794 23.7665 74.9461C23.477 74.5127 23.0656 74.1748 22.5842 73.9752C22.1028 73.7755 21.5731 73.723 21.0619 73.8244C20.5507 73.9257 20.081 74.1763 19.7121 74.5445C19.3433 74.9126 19.0919 75.3819 18.9896 75.8929C18.8874 76.4039 18.9389 76.9338 19.1377 77.4155C19.3365 77.8973 19.6736 78.3093 20.1065 78.5995C20.5394 78.8897 21.0485 79.0451 21.5697 79.046C21.9162 79.0466 22.2595 78.9789 22.5799 78.8467C22.9002 78.7145 23.1914 78.5205 23.4366 78.2756C23.6819 78.0308 23.8765 77.74 24.0093 77.4199C24.142 77.0998 24.2104 76.7566 24.2104 76.41Z"
      fill="#656D78"
    />
    <circle
      cx="59.3811"
      cy="19.8595"
      r="17.8712"
      fill="#FD7919"
      stroke="white"
      stroke-width="3.97651"
    />
    <path
      d="M59.4041 20.2612V11.5508"
      stroke="white"
      stroke-width="2.17761"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M56.1377 16.9949L59.3094 20.1666C59.3617 20.2188 59.4466 20.2188 59.4988 20.1666L62.6705 16.9949"
      stroke="white"
      stroke-width="2.17761"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M49.6049 19.1725V20.2613V23.5277C49.6049 24.7304 50.5798 25.7053 51.7825 25.7053H67.0258C68.2285 25.7053 69.2034 24.7304 69.2034 23.5277V20.2613V19.1725"
      stroke="white"
      stroke-width="2.17761"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    *ngIf="type === 'generate-training'"
    width="114"
    height="85"
    viewBox="0 0 117 89"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="generate-training-svg"
  >
    <path
      d="M57.3103 15.2783H37.3552C34.6026 15.2783 32.3665 17.5169 32.3665 20.267V35.2334C32.3665 37.986 34.23 40.2221 36.5221 40.2221C38.8143 40.2221 40.6802 37.986 40.6802 35.2334V25.2559C40.6802 24.34 41.4255 23.5946 42.344 23.5946H52.3216C53.2375 23.5946 53.9829 24.34 53.9829 25.2559V35.2335C53.9829 37.9862 55.8487 40.2223 58.1409 40.2223C60.4332 40.2223 62.299 37.9862 62.299 35.2335V20.267C62.2992 17.5171 60.0606 15.2783 57.3103 15.2783Z"
      fill="#434A54"
    />
    <path
      d="M64.9688 35.8885C60.2577 31.1775 53.9949 28.5833 47.3328 28.5833C40.6681 28.5833 34.4053 31.1776 29.6943 35.8885C24.9832 40.5996 22.389 46.8624 22.389 53.527C22.389 57.9045 23.5388 62.2135 25.7164 65.9843C27.8283 69.6407 30.8585 72.7243 34.4759 74.9045C34.7366 75.0605 35.0313 75.1432 35.3359 75.1432H59.3273C59.6318 75.1432 59.9266 75.0605 60.1872 74.9045C63.8045 72.7244 66.8349 69.6407 68.9469 65.9843C71.1247 62.2133 72.2769 57.9045 72.2769 53.527C72.2767 46.8624 69.68 40.5996 64.9688 35.8885Z"
      fill="#656D78"
    />
    <path
      d="M110.019 64.095H42.0979C41.0559 64.095 40.2104 64.938 40.2104 65.9798V73.5274C40.2104 74.5694 41.0561 75.415 42.0979 75.415H110.019C111.061 75.415 111.906 74.5694 111.906 73.5274V65.9798C111.906 64.938 111.061 64.095 110.019 64.095Z"
      fill="#CCD1D9"
    />
    <path
      d="M53.4181 56.5469C50.2979 56.5469 47.7581 59.0867 47.7581 62.2071V77.2997C47.7581 80.4227 50.2979 82.9599 53.4181 82.9599C56.5383 82.9599 59.0783 80.4227 59.0783 77.2997V62.2071C59.0781 59.0869 56.5383 56.5469 53.4181 56.5469Z"
      fill="#D36413"
    />
    <path
      d="M62.8506 50.8872C59.7303 50.8872 57.1904 53.4271 57.1904 56.5471V82.9601C57.1904 86.0827 59.7303 88.6199 62.8506 88.6199C65.9708 88.6199 68.5107 86.0827 68.5107 82.9601V56.5469C68.5105 53.427 65.9708 50.8872 62.8506 50.8872Z"
      fill="#FD7919"
    />
    <path
      d="M98.6985 56.5469C95.5784 56.5469 93.0387 59.0867 93.0387 62.2071V77.2997C93.0387 80.4227 95.5784 82.9599 98.6985 82.9599C101.819 82.9599 104.359 80.4227 104.359 77.2997V62.2071C104.359 59.0869 101.819 56.5469 98.6985 56.5469Z"
      fill="#D36413"
    />
    <path
      d="M89.2634 50.8872C86.143 50.8872 83.6031 53.4271 83.6031 56.5471V82.9601C83.6031 86.0827 86.143 88.6199 89.2634 88.6199C92.3864 88.6199 94.9234 86.0827 94.9234 82.9601V56.5469C94.9234 53.427 92.3866 50.8872 89.2634 50.8872Z"
      fill="#FD7919"
    />
    <path
      d="M111.906 67.8672C111.423 67.8672 110.939 68.0524 110.571 68.4199C109.834 69.1579 109.834 70.3518 110.571 71.0866C110.939 71.457 111.423 71.6394 111.906 71.6394V67.8672Z"
      fill="#AAB2BC"
    />
    <path
      d="M40.2104 67.8672V71.6394C40.694 71.6394 41.1776 71.457 41.5451 71.0866C42.2803 70.3518 42.2803 69.1579 41.5451 68.4199C41.1776 68.0526 40.694 67.8672 40.2104 67.8672Z"
      fill="#AAB2BC"
    />
    <circle
      cx="92.8086"
      cy="27.1107"
      r="20.4242"
      stroke="white"
      stroke-width="6.58845"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M99.9703 27.9961H94.0022V33.9643C94.0022 34.6207 93.4686 35.1579 92.8086 35.1579C92.1485 35.1579 91.615 34.6207 91.615 33.9643V27.9961H85.6468C84.9868 27.9961 84.4532 27.459 84.4532 26.8025C84.4532 26.146 84.9868 25.6089 85.6468 25.6089H91.615V19.6408C91.615 18.9843 92.1485 18.4472 92.8086 18.4472C93.4686 18.4472 94.0022 18.9843 94.0022 19.6408V25.6089H99.9703C100.63 25.6089 101.164 26.146 101.164 26.8025C101.164 27.459 100.63 27.9961 99.9703 27.9961ZM92.8086 7.70459C82.2605 7.70459 73.7106 16.2509 73.7106 26.8025C73.7106 37.3541 82.2605 45.9005 92.8086 45.9005C103.357 45.9005 111.907 37.3541 111.907 26.8025C111.907 16.2509 103.357 7.70459 92.8086 7.70459Z"
      fill="#FD7919"
    />
    <path
      d="M29.3507 22.6579L45.4567 20.0145L29.3507 17.3522L30.1914 15.2653L28.1045 16.106L25.4422 0L22.7988 16.106L20.693 15.2653L21.5337 17.3522L5.42773 20.0145L21.5337 22.6579L20.693 24.7636L22.7988 23.9229L25.4422 40.0289L28.1045 23.9229L30.1914 24.7636L29.3507 22.6579Z"
      fill="#FD7919"
    />
    <path
      d="M15.0026 44.0612L25.103 42.4035L15.0026 40.7339L15.5298 39.4252L14.2211 39.9524L12.5515 29.8521L10.8938 39.9524L9.57321 39.4252L10.1004 40.7339L6.10352e-05 42.4035L10.1004 44.0612L9.57321 45.3818L10.8938 44.8546L12.5515 54.9549L14.2211 44.8546L15.5298 45.3818L15.0026 44.0612Z"
      fill="#FD7919"
    />
  </svg>
</ng-template>
